import api from '../index';

export const GetNotificationApi = () => api.post('notificationlist');
export const DeleteNotificationApi = (data) => api.post('notificationdelete', data);
export const MarkAsReadNotificationApi = (data) => api.post('marknotificationasread', data);